import { useState, useRef, useCallback, useEffect } from 'react';

export default function useStateDelayed<T>(
  initialValue: T,
  delay: number,
): [T, (value: T) => void] {
  const [state, setState] = useState(initialValue);
  const timeRef = useRef<NodeJS.Timeout | null>(null);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const setDelayedState = useCallback(
    (value: T) => {
      if (timeRef.current !== null) clearTimeout(timeRef.current);

      timeRef.current = setTimeout(() => {
        if (isMounted.current) {
          setState(value);
        }
        timeRef.current = null;
      }, delay);
    },
    [setState, delay],
  );

  return [state, setDelayedState];
}
